"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../layout");
var input_1 = require("../input");
var Text_1 = __importDefault(require("../Text"));
var react_error_boundary_1 = require("react-error-boundary");
var ErrorFallback = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Something went wrong' : _b;
    var resetBoundary = react_error_boundary_1.useErrorBoundary().resetBoundary;
    return (react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", gap: 8 },
        react_1.jsx(Text_1.default.Body, null, title),
        react_1.jsx(input_1.Button, { hierarchy: "secondary", onClick: resetBoundary }, "Try Again")));
};
exports.default = ErrorFallback;
